import { Card } from "react-bootstrap";

import { FileRow } from "../../../common/components";
import {
    BesuClaimApprovers,
    ApproverDetailsPersonalInfo,
} from "../../../types/claim";
import { formatToDate } from "../../../utils/common";

import { ClaimApproversTable } from "./ClaimApproversTable";
import { ClaimFormValues } from "./ClaimForm";
import React, { useMemo } from "react";
import {SectionTitle} from "@blueprint/ui";

type ClaimPreviewProps = {
    formValues: ClaimFormValues;
    claimApprovers: ApproverDetailsPersonalInfo[];
};

const ClaimPreview = ({
    formValues,
    claimApprovers,
}: ClaimPreviewProps): JSX.Element => {
    const claimApproversFormatted: BesuClaimApprovers[] = useMemo(() => {
        return claimApprovers.map((it) => ({
            status: undefined,
            details: it,
            actionTimestamp: undefined,
        }));
    }, [claimApprovers]);

    return (
        <Card className="mb-5 border-0">
            <dl>
                <Card.Header className="px-0 py-2">
                    <h2 className="mb-0 rem-1">Claim Submission</h2>
                </Card.Header>
                <Card.Body className="px-0 py-3">
                    <dt>
                        <SectionTitle className="mb-3 rem-1" variant="h3">Creation Date</SectionTitle>
                    </dt>
                    <dd className="mb-5 fw-bold">
                        {formatToDate(
                            formValues.createdAt ?? new Date().toISOString(),
                        )}
                    </dd>
                    <dt>
                        <SectionTitle className="mb-3 rem-1" variant="h3">Claim Description</SectionTitle>
                    </dt>
                    <dd className="text-pre-wrap mb-5 fw-bold">
                        {formValues.description}
                    </dd>
                    <dt>
                        <SectionTitle className="mb-3 rem-1" variant="h3">Document List</SectionTitle>
                    </dt>
                    {formValues.files.map((file, index) => (
                        <dd><FileRow key={index} file={file} /></dd>
                    ))}
                    <dt className="mb-3 mt-5 rem-1">Claim Approvers</dt>
                    <dd>
                        <ClaimApproversTable data={claimApproversFormatted} />
                    </dd>
                </Card.Body>
            </dl>
        </Card>

    );
};

export default ClaimPreview;
